export interface AuthResponse {
  access_token: string;
  expires_in: number;
}
